export const currentPartiesCode = {
  'adelante-andalucia': 'por-a',
  'recortes-cero-m-j-gv': 'recortes-cero',
};

export function overrideParties(partiesCode) {
  return function (party) {
    if (Object.hasOwnProperty.call(partiesCode, party.partyCode)) {
      return { ...party, partyCode: partiesCode[party.partyCode] };
    }
    return party;
  };
}
